import { css } from '@/styled-system/css';

export const skeletonBlock = css({
  display: 'block',
  backgroundColor: 'bg.softer',
  borderRadius: 'sm',
});
